<template>
  <nuxt />
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api'
import useListeningToRefreshToken from '../../composables/useListeningToRefreshToken'
import useForceLogoutV2 from '../../composables/useForceLogoutV2'
import useDeviceId from '../../composables/useDeviceId'

export default defineComponent({
  setup(props, context) {
    useListeningToRefreshToken(context)
    useForceLogoutV2(context)
    useDeviceId() // 登入跟註冊皆會需要 deviceId 做為參數要求
  }
})
</script>
